module.exports = __webpack_public_path__ + "static/img/img_BG.04568292.png";